import { memo } from "react";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { Box, Chip, Typography } from "@mui/material";
import React from "react";
import { RateAndReview } from "@tlc/ls2pac/components/rate-and-review/RateAndReview";
import { RequestButton } from "@tlc/ls2pac/components/place-hold/RequestButton";
import { LSResultItemAvailability } from "./LSResultItemAvailability";
import { LSResultItemLayout } from "./LSResultItemLayout";
import { LSResultItemCheckbox } from "./LSResultItemCheckbox";
import { LSResultItemAuthor } from "./LSResultItemAuthor";
import { LSResultItemBookjacket } from "./LSResultItemBookjacket";
import { LSResultItemAddToListButton } from "./LSResultItemAddToListButton";
import { LSResultItemReadingLevelDisplay } from "./LSResultItemReadingLevelDisplay";
import { LSResultItemShelfLocation } from "./LSResultItemShelfLocation";
import { LSResultItemTitle } from "./LSResultItemTitle";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { ResourceSeriesLink } from "../ResourceSeriesLink";

interface LSResultProps {
  resource: ResourceView;
}

export const LSResultItem = memo(
  function SearchResult({ resource }: LSResultProps) {
    const { translate } = useLanguage();

    const actionsComponent = (
      <>
        <RequestButton resource={resource} />
        <LSResultItemAddToListButton
          resource={resource}
        ></LSResultItemAddToListButton>
      </>
    );

    return (
      <LSResultItemLayout
        checkboxComponent={<LSResultItemCheckbox resource={resource} />}
        bookjacketComponent={<LSResultItemBookjacket resource={resource} />}
        titleComponent={<LSResultItemTitle resource={resource} />}
        actionsComponent={actionsComponent}
        authorComponent={
          <LSResultItemAuthor shortAuthor={resource.shortAuthor} />
        }
      >
        {/* Format label and rating */}
        <Box display="flex" alignItems="center" gap={2}>
          {resource.format && (
            <Box>
              <Chip variant="outlined" label={resource.format} />
            </Box>
          )}

          {resource.rtype === 1 && (
            <RateAndReview material={resource}></RateAndReview>
          )}
        </Box>

        {/* Series */}
        {resource.mainSeries && (
          <Typography variant="subtitle2">
            {translate("series")}: <ResourceSeriesLink resource={resource} />
          </Typography>
        )}

        <LSResultItemReadingLevelDisplay resource={resource} />
        <LSResultItemAvailability resource={resource} />
        <LSResultItemShelfLocation resource={resource} />
      </LSResultItemLayout>
    );
  },
  (prevProps, nextProps) => prevProps.resource.id === nextProps.resource.id
);
